import { maxBy } from "lodash";
import { useMemo } from "react";
import { OLAPTransformerResult } from "../../../shared";

const CATEGORY_AXIS = "calendar.default";

export function usePricesDateLabel(olapData: OLAPTransformerResult | null) {
  const pricesDateLabel = useMemo(() => {
    const maxColumn = maxBy(olapData?.columns, col => col.selection[CATEGORY_AXIS] as number);
    const dateString = maxColumn?.headers.find(h => h.id === `${CATEGORY_AXIS}.name`)?.name || '';
    return dateString;
  }, [olapData]);
  return pricesDateLabel;
}